module.exports = __webpack_public_path__ + "img/presaincarico.d4be2f3b.png";